import { Injectable } from "@angular/core";
import { NgbDateAdapter, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";

@Injectable()
export class CustomAdapter extends NgbDateAdapter<Date> {
  public fromModel = (date: Date | null) => {

    var value = new Date(date ?? '');
    return !value
      ? null
      : {
        year: value.getUTCFullYear(),
        month: value.getUTCMonth() + 1, // NgbDateStruct months start at 1
        day: value.getUTCDate()
      };
  }

  public toModel = (date: NgbDateStruct | null) => date
    ? new Date(Date.UTC(date.year, date.month - 1, date.day))
    : null;
}
